// extracted by mini-css-extract-plugin
module.exports = {"logo":"Intro_logo__2TmsF","video_background":"Intro_video_background__3mafe"};